module.exports = __webpack_public_path__ + "static/img/live-logo.419313da.gif";